import { Circle as CircleStyle, Fill, RegularShape, Style } from 'ol/style';
import color from 'client/utils/constants/GDS/js/color';
import { LINE_STRING, POLYGON } from 'client/utils/constants/geometryType';
import { Geometry, MultiPoint } from 'ol/geom';

export const vertexStyle = new Style({
    image: new RegularShape({
        points: 4,
        radius: 4,
        angle: Math.PI / 4,
        fill: new Fill({
            color: color.black
        })
    })
});

export const lastVertexStyle = new Style({
    image: new CircleStyle({
        radius: 4,
        fill: new Fill({
            color: color.black
        })
    })
});

export const addVertex = (geometry, styles, highlightLastLineVertex = false) => {
    if (!geometry || !(geometry instanceof Geometry)) {
        return new Error('Invalid geometry object');
    }
    const geometryType = geometry?.getType();
    const style = vertexStyle;
    if (geometryType === POLYGON) {
        const points = geometry.getCoordinates()[0].slice(0, -1);
        style.setGeometry(new MultiPoint(points));
        styles.push(style);
    } else if (geometryType === LINE_STRING) {
        const points = geometry.getCoordinates();
        if (!highlightLastLineVertex) {
            style.setGeometry(new MultiPoint(points));
            styles.push(style);
            return;
        }

        // In sketch mode, OL keeps the cursor-following coordinate as the last
        // point in the LineString; the last placed point is therefore penultimate.
        if (points.length <= 1) {
            lastVertexStyle.setGeometry(new MultiPoint(points));
            styles.push(lastVertexStyle);
            return;
        }

        const fixedLastPointIndex = points.length - 2;
        const squarePoints = points.slice(0, -1).filter((point, index) => index !== fixedLastPointIndex);

        if (squarePoints.length > 0) {
            style.setGeometry(new MultiPoint(squarePoints));
            styles.push(style);
        }

        lastVertexStyle.setGeometry(new MultiPoint([points[fixedLastPointIndex]]));
        styles.push(lastVertexStyle);
    }
};
